// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/branding.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { BrandingSettingsService } from "./branding";
import type { IntrospectBrandingResponse } from "./branding";
import type { IntrospectBrandingRequest } from "./branding";
import type { SetBrandingFaviconWhiteResponse } from "./branding";
import type { SetBrandingFaviconWhiteRequest } from "./branding";
import type { SetBrandingFaviconResponse } from "./branding";
import type { SetBrandingFaviconRequest } from "./branding";
import type { SetBrandingLogoWhiteResponse } from "./branding";
import type { SetBrandingLogoWhiteRequest } from "./branding";
import type { SetBrandingLogoResponse } from "./branding";
import type { SetBrandingLogoRequest } from "./branding";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { UpdateBrandingSettingsResponse } from "./branding";
import type { UpdateBrandingSettingsRequest } from "./branding";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.settings.v1.BrandingSettingsService
 */
export interface IBrandingSettingsServiceClient {
    /**
     * @generated from protobuf rpc: Update(c1.api.settings.v1.UpdateBrandingSettingsRequest) returns (c1.api.settings.v1.UpdateBrandingSettingsResponse);
     */
    update(input: UpdateBrandingSettingsRequest, options?: RpcOptions): UnaryCall<UpdateBrandingSettingsRequest, UpdateBrandingSettingsResponse>;
    /**
     * @generated from protobuf rpc: SetBrandingLogo(c1.api.settings.v1.SetBrandingLogoRequest) returns (c1.api.settings.v1.SetBrandingLogoResponse);
     */
    setBrandingLogo(input: SetBrandingLogoRequest, options?: RpcOptions): UnaryCall<SetBrandingLogoRequest, SetBrandingLogoResponse>;
    /**
     * @generated from protobuf rpc: SetBrandingLogoWhite(c1.api.settings.v1.SetBrandingLogoWhiteRequest) returns (c1.api.settings.v1.SetBrandingLogoWhiteResponse);
     */
    setBrandingLogoWhite(input: SetBrandingLogoWhiteRequest, options?: RpcOptions): UnaryCall<SetBrandingLogoWhiteRequest, SetBrandingLogoWhiteResponse>;
    /**
     * @generated from protobuf rpc: SetBrandingFavicon(c1.api.settings.v1.SetBrandingFaviconRequest) returns (c1.api.settings.v1.SetBrandingFaviconResponse);
     */
    setBrandingFavicon(input: SetBrandingFaviconRequest, options?: RpcOptions): UnaryCall<SetBrandingFaviconRequest, SetBrandingFaviconResponse>;
    /**
     * @generated from protobuf rpc: SetBrandingFaviconWhite(c1.api.settings.v1.SetBrandingFaviconWhiteRequest) returns (c1.api.settings.v1.SetBrandingFaviconWhiteResponse);
     */
    setBrandingFaviconWhite(input: SetBrandingFaviconWhiteRequest, options?: RpcOptions): UnaryCall<SetBrandingFaviconWhiteRequest, SetBrandingFaviconWhiteResponse>;
    /**
     * @generated from protobuf rpc: Introspect(c1.api.settings.v1.IntrospectBrandingRequest) returns (c1.api.settings.v1.IntrospectBrandingResponse);
     */
    introspect(input: IntrospectBrandingRequest, options?: RpcOptions): UnaryCall<IntrospectBrandingRequest, IntrospectBrandingResponse>;
}
/**
 * @generated from protobuf service c1.api.settings.v1.BrandingSettingsService
 */
export class BrandingSettingsServiceClient implements IBrandingSettingsServiceClient, ServiceInfo {
    typeName = BrandingSettingsService.typeName;
    methods = BrandingSettingsService.methods;
    options = BrandingSettingsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Update(c1.api.settings.v1.UpdateBrandingSettingsRequest) returns (c1.api.settings.v1.UpdateBrandingSettingsResponse);
     */
    update(input: UpdateBrandingSettingsRequest, options?: RpcOptions): UnaryCall<UpdateBrandingSettingsRequest, UpdateBrandingSettingsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateBrandingSettingsRequest, UpdateBrandingSettingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetBrandingLogo(c1.api.settings.v1.SetBrandingLogoRequest) returns (c1.api.settings.v1.SetBrandingLogoResponse);
     */
    setBrandingLogo(input: SetBrandingLogoRequest, options?: RpcOptions): UnaryCall<SetBrandingLogoRequest, SetBrandingLogoResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetBrandingLogoRequest, SetBrandingLogoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetBrandingLogoWhite(c1.api.settings.v1.SetBrandingLogoWhiteRequest) returns (c1.api.settings.v1.SetBrandingLogoWhiteResponse);
     */
    setBrandingLogoWhite(input: SetBrandingLogoWhiteRequest, options?: RpcOptions): UnaryCall<SetBrandingLogoWhiteRequest, SetBrandingLogoWhiteResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetBrandingLogoWhiteRequest, SetBrandingLogoWhiteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetBrandingFavicon(c1.api.settings.v1.SetBrandingFaviconRequest) returns (c1.api.settings.v1.SetBrandingFaviconResponse);
     */
    setBrandingFavicon(input: SetBrandingFaviconRequest, options?: RpcOptions): UnaryCall<SetBrandingFaviconRequest, SetBrandingFaviconResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetBrandingFaviconRequest, SetBrandingFaviconResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetBrandingFaviconWhite(c1.api.settings.v1.SetBrandingFaviconWhiteRequest) returns (c1.api.settings.v1.SetBrandingFaviconWhiteResponse);
     */
    setBrandingFaviconWhite(input: SetBrandingFaviconWhiteRequest, options?: RpcOptions): UnaryCall<SetBrandingFaviconWhiteRequest, SetBrandingFaviconWhiteResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetBrandingFaviconWhiteRequest, SetBrandingFaviconWhiteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Introspect(c1.api.settings.v1.IntrospectBrandingRequest) returns (c1.api.settings.v1.IntrospectBrandingResponse);
     */
    introspect(input: IntrospectBrandingRequest, options?: RpcOptions): UnaryCall<IntrospectBrandingRequest, IntrospectBrandingResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<IntrospectBrandingRequest, IntrospectBrandingResponse>("unary", this._transport, method, opt, input);
    }
}
